import React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';
import { getMediaQuery } from '@carvana/showroom-theme';
import { useAnalytics } from '../utils/analytics-provider/analytics-provider';
import CaretRightIcon from '../images/icons/carrot-right.svg';
import { sanitizeUrl } from '../utils/sanitize-url';

const ArticleCarrotWrapper = styled(Link)`
  text-decoration: none;
  color: ${(props) => props.theme.color.primary.v600};
  padding-bottom: 1.25rem;
  font-size: 0.875rem;
  line-height: 1.25rem;

  > span {
    white-space: nowrap;
    display: inline;
  }

  &:hover {
    text-decoration: none;
    color: ${(props) => props.theme.color.primary.v600};
  }

  ${(props) => getMediaQuery(props.theme.breakpoint.md)} {
    padding-bottom: 1.75rem;
  }
`;

const CaretRight = styled(CaretRightIcon)`
  width: 16px;
  height: 16px;
  position: relative;
  top: 3px;
  left: -4px;
`;

export const ArticleLink = ({ article }) => {
  const { trackEvent } = useAnalytics();
  const sanitizedUrl =
    (article.article_url &&
      article?.topic?.topic_url &&
      `/${sanitizeUrl(article?.topic?.topic_url)}/${sanitizeUrl(article.article_url)}`) ||
    (article?.url && sanitizeUrl(article?.url)) ||
    '';
  const name = article?.name || article?.article_name || article?.headline;

  const onLinkClick = ({ to }) => {
    trackEvent('content_engagement_v2', {
      engagement_type: 'link_click',
      link: to,
      data: article
    });
  };

  return (
    <ArticleCarrotWrapper
      to={sanitizedUrl}
      key={name}
      onClick={() => onLinkClick({ to: sanitizedUrl })}
    >
      {name}
      <span>
        &nbsp;
        <CaretRight />
      </span>
    </ArticleCarrotWrapper>
  );
};
